import FormCarInfoPage from "./FormCarInfoPage"

export default FormCarInfoPage
